import { OidcClient } from '@axa-fr/react-oidc'
import { defaultConfigurationName } from 'constants/oidcProvider'

export const getOidcAccessToken = (configurationName = defaultConfigurationName) => {
  const getOidc = OidcClient.get
  const oidc = getOidc(configurationName)
  return { accessToken: oidc.tokens?.accessToken, accessTokenPayload: oidc.tokens?.accessTokenPayload }
}

export function getUserName(oidcUser) {
  return oidcUser?.profile?.firstName ? `${oidcUser.profile.name} ${oidcUser.profile.lastName}` : oidcUser?.sub ? oidcUser.sub : 'User'
}
